/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { toHeaderCase } from "js-convert-case";
import config from "../config/featuresCommitteeSection.config.json";
import moment from "moment";
import jwt_decode from "jwt-decode";

import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface IFeatureSectionMethods extends IPluginMethodMap {
  getFeatureSectionProps(args: any): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const lookup = require("country-code-lookup");

export class FeatureSectionService implements IAgentPlugin {
  readonly methods: IFeatureSectionMethods;

  constructor() {
    this.methods = {
      getFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_POLICY_DETAIL,
    //       variables: {
    //         input: {
    //           policyId: policyNumber,
    //         },
    //         input1: {
    //           limit: 100,
    //           where: [
    //             {
    //               column: "txnOwner",
    //               op: "Equal",
    //               value: [userVid],
    //             },
    //             {
    //               column: "type",
    //               op: "In",
    //               value: ["POLICY_PURCHASE_FLOW", "KYC_SUBMISSION"],
    //             },
    //             {
    //               column: "txnSetId",
    //               op: "In",
    //               value: [policyNumber, null],
    //             },
    //           ],
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getPolicyDetail) {
    //       console.log(`policy details`, res?.data?.getPolicyDetail);
    //       let _result = res?.data?.getPolicyDetail;
    //       let _txtResult = res?.data?.getTxnList;
    //       return {
    //         policyId: _result?.policyId,
    //         title: _result?.policyNumber,
    //         premium: _result?.premium,
    //         subTitle: _result?.policyNumber,
    //         minDue: _result?.minDue,
    //         listItems: this.getListItems(_result),
    //         beneficiaryDetails: this.getBeneficiary(_result?.benificiaryDetail),
    //         policyDocument: `data:application/pdf;base64,${_result?.pdf}`,
    //         policyDetails: this.getPolicyDetails(_result),
    //         carouselItems: this.getCarouselItems(_result),
    //         timelineDetails: this.getTransactionDetail(_txtResult),
    //         useOfProceedDetails: this.getUseOfProceeds(_result),
    //         buttons: await this.getButtons(_result?.payments),
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   console.log(`Sign In user error`, err?.response?.data);
    //   throw Error(err?.response?.data?.error?.display_message);
    // }
    return { ...(config || {}) };
  }
}
